import { isEmpty, merge } from 'lodash-es';

export const useValuesFromUrl = (reference, configuration, filteredConfiguration) => {
  const updateValuesFromUrlParams = () => {
    const url = new URL(window.location.href);
    reference.value = url.searchParams.get('reference');
    configuration.value = merge(
      JSON.parse(JSON.stringify(configuration.value)),
      JSON.parse(url.searchParams.get('configuration')),
    );
  };

  const updateUrlParamsFromValues = () => {
    const url = new URL(window.location.href);

    if (reference.value !== null) {
      url.searchParams.set('reference', reference.value);
    }

    if (!isEmpty(filteredConfiguration.value)) {
      url.searchParams.set('configuration', JSON.stringify(filteredConfiguration.value));
    } else {
      url.searchParams.delete('configuration');
    }

    const newUrl = url.toString();
    window.history.replaceState({ path: newUrl }, '', newUrl);
  };

  return {
    updateValuesFromUrlParams,
    updateUrlParamsFromValues,
  };
};
